export default __webpack_public_path__ + "img/new_badge.png";